// Thin WebSocket client for live game sync.
const WS_BASE =
  import.meta.env.VITE_WS_BASE || 'wss://pubgolfgame.com/ws';

export function connectToGame(sessionCode, onSync) {
  let ws;
  let closed = false;
  let retry = 0;

  const connect = () => {
    ws = new WebSocket(WS_BASE);

    ws.onopen = () => {
      retry = 0;
      try {
        ws.send(JSON.stringify({ type: 'join', sessionCode }));
      } catch {}
    };

    ws.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        onSync(msg);
      } catch (err) {
        console.warn('WS parse error', err);
      }
    };

    ws.onerror = (e) => console.warn('WS error', e);

    ws.onclose = () => {
      if (closed) return;
      // Exponential backoff reconnect
      retry += 1;
      const delay = Math.min(1000 * 2 ** retry, 15000);
      setTimeout(connect, delay);
    };
  };

  connect();

  return {
    sendUpdate(state, teams, currentHole, extras = {}) {
      if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(
          JSON.stringify({
            type: 'update',
            sessionCode,
            state,
            teams,
            currentHole,
            ...extras,
          })
        );
      }
    },
    disconnect() {
      closed = true;
      try {
        ws && ws.close();
      } catch {}
    },
  };
}
